import { STATES } from '@/constants/patient';

export const OOO_COLUMN_OPTIONS_LIST = [
  { value: 'status', text: 'Status' },
  { value: 'doctor', text: 'Doctor' },
  { value: 'state', text: 'State' },
  { value: 'reassignTo', text: 'Reassign To' },
  { value: 'startDate', text: 'Start Date' },
  { value: 'endDate', text: 'End Date' },
];

export const OOO_STATUS_OPTIONS_LIST = [
  { value: 'PENDING', text: 'Pending' },
  { value: 'APPROVED', text: 'Approved' },
  { value: 'ACTIVE', text: 'Active' },
  { value: 'CANCELLED', text: 'Cancelled' },
  { value: 'DENIED', text: 'Denied' },
  { value: 'RETURNED', text: 'Completed' },
];

export const OOO_REASSIGNMENT_STATUS_OPTIONS_LIST = [
  { value: 'PENDING', text: 'Pending' },
  { value: 'PROCESSING', text: 'Processing' },
  { value: 'APPROVED', text: 'Approved' },
  { value: 'TRANSFERRED', text: 'Transferred' },
  { value: 'RETURNED', text: 'Returned' },
  { value: 'CANCELLED', text: 'Cancelled' },
  { value: 'DENIED', text: 'Denied' },
  { value: 'REJECTED', text: 'Rejected' },
];

export const OOO_STATE_OPTIONS_LIST = STATES.map(s => ({
  value: s.code,
  text: `${s.statename} (${s.code})`,
}));

export const OOO_TABLE_HEADERS_LIST = [
  { key: 'startdatestamp', label: 'Start Date' },
  { key: 'enddatestamp', label: 'End Date' },
  { key: 'name', label: 'Doctor' },
  { key: 'requeststatus', label: 'Status' },
  { key: 'coveredstate', label: 'State' },
  { key: 'doctorlistdetails', label: 'Reassign To' },
  { key: 'actions', label: 'Actions' },
];

export const OOO_STATUS_OPTIONS = Object.values(OOO_STATUS_OPTIONS_LIST).reduce((acc, option) => {
  acc[option.value] = option.value;

  return acc;
}, {});

export const OOO_REASSIGNMENT_STATUS_OPTIONS = Object.values(OOO_REASSIGNMENT_STATUS_OPTIONS_LIST).reduce((acc, option) => {
  acc[option.value] = option.value;

  return acc;
}, {});

export const REASSIGNMENT_TYPE = {
  TEMPORARY: 'TEMPORARY',
  PERMANENT: 'PERMANENT',
}
